<div class="error-page-root">
  <div
    class="gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-large gw-w-full gw-max-w-[480px]"
  >
    <!-- Icon badge -->
    <div
      class="gw-flex gw-h-20 gw-w-20 gw-items-center gw-justify-center gw-rounded-full gw-bg-background-neutral-1"
    >
      <gatewee-icon
        [icon]="resolvedIcon"
        size="2.5rem"
        iconStyle="secondary"
      ></gatewee-icon>
    </div>

    <!-- Text -->
    <div class="gw-flex gw-flex-col gw-gap-small">
      <span
        class="gw-text-xs gw-font-semibold gw-uppercase gw-tracking-widest gw-text-text-tertiary"
      >
        {{ resolvedCode }}
      </span>
      <h1 class="gw-m-0 gw-text-2xl gw-font-semibold gw-text-text-primary">
        {{ resolvedTitleKey | translate }}
      </h1>
      <p class="gw-m-0 gw-text-sm gw-text-text-secondary">
        {{ resolvedDescriptionKey | translate }}
      </p>
    </div>

    <!-- CTA -->
    <a [routerLink]="ctaLink" class="gw-w-full gw-max-w-[240px]">
      <gatewee-button
        variant="primary"
        class="gw-w-full"
        [title]="ctaKey | translate"
        [iconName]="'@phi.house'"
      ></gatewee-button>
    </a>
  </div>
</div>
